// extracted by mini-css-extract-plugin
export default {"section":"PerformanceBlock_section__1J3Dh","performanceSection":"PerformanceBlock_performanceSection__68+x8","graphs":"PerformanceBlock_graphs__XC+Al"};